import type { TotalContractsFilterState } from '../types/filters'

/** Active filter count for toolbar badge (search + drawer fields). */
export function countActiveTotalContractsFilters(
  filters: TotalContractsFilterState & { q?: string },
  lockedCompanyId?: string,
  lockedPropertyId?: string,
): number {
  let count = 0
  if (filters.q?.trim()) count += 1
  if (filters.company_id && filters.company_id !== lockedCompanyId) count += 1
  if (filters.property_id && filters.property_id !== lockedPropertyId) count += 1
  if (filters.special_note?.trim()) count += 1
  if (filters.source?.trim()) count += 1
  if (filters.status?.length) count += 1
  if (filters.gateway_status?.length) count += 1
  if (filters.fromDt || filters.toDt) count += 1
  if (filters.contract_start_fromDt || filters.contract_start_toDt) count += 1
  return count
}
